<script setup lang="ts">
import type { AcceptableValue } from 'reka-ui';
import { ComboboxItem } from 'reka-ui';

interface Props {
    value: AcceptableValue;
}
defineProps<Props>();
</script>

<template>
    <combobox-item
        class="text-[13px] leading-none text-green-700 cursor-pointer rounded-[3px] flex items-center h-[25px] px-4 relative select-none data-disabled:text-gray-800 data-disabled:pointer-events-none data-highlighted:outline-hidden data-highlighted:bg-green-600 data-highlighted:text-green-100"
        :value="value"
    >
        <slot />
    </combobox-item>
</template>
